import { CanvasObject } from "./object.js";

// groups can be used either permanent or temporary 
class GroupObject extends CanvasObject {
    constructor({
        context,
        saveState = null,
    }) {
        super(context);
        this.name = "Group Object";

        this.objects = [];

        this._init();
    }
    init() {
        return;

        // this will only be executed if the user decided to create a object, otherwise temp use does not require this
        this.context.canvas.dispatchEvent(new CustomEvent('creator:object:create', {detail: {object: this}}));
        this.context.canvas.addEventListener('creator:object:edit:finish', (event) => {
            this.editing = false;
            this.selected = false;

            this.context.canvas.dispatchEvent(new CustomEvent('creator:object:update', 
                {
                    detail: {
                        context: this.context,
                        object: this
                    }
                }
            ));
        });
        
        this._generateObjectID();
        this._objectEvents();
    }
    _init() {

    }
    _getObjectBoundingRect() {
        const bounds = {
            ...this.position,
            ...this.dimensions
        }
        this.boundingRect = bounds;

        return bounds;
    }
    addObjectToGroup({
        o_context
    }) {
        if( o_context instanceof Array ) {
            o_context.forEach( c => this.objects.push(c) );
        } else {
            this.objects.push( o_context );
        }

        // set new position and dimensions
        this.position.x = null;
        this.position.y = null;
        this.dimensions.max_x = null;
        this.dimensions.max_y = null;
        this.dimensions.width = null;
        this.dimensions.height = null;

        this.objects.forEach( o_context => {
            this.position.x = (this.position.x === null) ? o_context.position.x : Math.min(o_context.position.x, this.position.x);
            this.position.y = (this.position.y === null) ? o_context.position.y : Math.min(o_context.position.y, this.position.y);
            if(this.dimensions.max_x === null) {
                this.dimensions.max_x = o_context.position.x + o_context.dimensions.width;
            } else {
                this.dimensions.max_x = Math.max(o_context.position.x + o_context.dimensions.width, this.dimensions.max_x);
            }
            if(this.dimensions.max_y === null) {
                this.dimensions.max_y = o_context.position.y + o_context.dimensions.height;
            } else {
                this.dimensions.max_y = Math.max(o_context.position.y + o_context.dimensions.height, this.dimensions.max_y)
            }
        });

        this.dimensions.width = Math.abs(this.dimensions.max_x - this.position.x);
        this.dimensions.height = Math.abs(this.dimensions.max_y - this.position.y);

        // recalulate bounds
        this._getObjectBoundingRect();
    }
    moveTo({x, y, before}) {
        this.position = {
            x: this.position.before.x + x,
            y: this.position.before.y + y,
            before: this.position.before
        };

        this.objects.forEach( o_context => {
            o_context.moveTo({
                x: x,
                y: y,
                before: o_context.position.before
            });
        });

        this._getObjectBoundingRect();
    }
    startDragObject({controls} = {}) {
        this.dragging = true;

        this.position.before = {
            ...this.position
        }

        this.objects.forEach( o_context => {
            o_context.dragging = true;
            o_context.position.before = {
                ...o_context.position
            }
        });

        controls.mouse.before = {
            x: controls.mouse.x,
            y: controls.mouse.y
        }
    }
}

export {
    GroupObject
}